import Big, { BigSource } from "big.js";

export const bigMath = {
	add: (base: BigSource = 0, ...values: (BigSource | undefined)[]) =>
		values
			.reduce<Big>(
				(prev, cur) => new Big(prev).add(cur ?? 0),
				new Big(base ?? 0),
			)
			.round(2)
			.toNumber(),
	sub: (base: BigSource = 0, ...values: (BigSource | undefined)[]) =>
		values
			.reduce<Big>(
				(prev, cur) => new Big(prev).sub(cur ?? 0),
				new Big(base ?? 0),
			)
			.round(2)
			.toNumber(),
	mul: (base: BigSource = 0, ...values: (BigSource | undefined)[]) =>
		values
			.reduce<Big>(
				(prev, cur) => new Big(prev).mul(cur ?? 0),
				new Big(base ?? 0),
			)
			.round(2)
			.toNumber(),
	div: (base: BigSource = 0, ...values: (BigSource | undefined)[]) =>
		values
			.reduce<Big>(
				// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- cannot divide by 0
				(prev, cur) => new Big(prev).div(cur || 1),
				new Big(base ?? 0),
			)
			.round(2)
			.toNumber(),
	mod: (base: BigSource = 0, ...values: (BigSource | undefined)[]) =>
		values
			.reduce<Big>(
				(prev, cur) => new Big(prev).mod(cur ?? 1),
				new Big(base ?? 0),
			)
			.round(2)
			.toNumber(),
};

export const isUndefinedOrNull = (val: any): val is undefined | null =>
	val === undefined || val === null;

export const isStringBlank = (val: any): val is undefined | null | string =>
	val === undefined || val === null || val.trim() === "";

/** App wide number formatter */
export function formatNumber(str?: BigSource, fixed = 2) {
	const arr = new Big(str ?? 0).round(fixed).toFixed(fixed).split(".");
	arr[0] = arr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

	return arr.join(".");
}
